<template>
  <b-modal :id="id" size="lg"
           ok-title="Закрыть" :ok-only="true" ok-variant="secondary"  @ok="onClose">
    <template slot="modal-title">
      Импорт КТЛО
    </template>

    <b-form @submit.prevent="onUpload" :disabled="loading">
      <b-form-row align-h="between">
        <div class="col-10">
          <b-file v-model="uploadForm.file" accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  browse-text="Выбрать" placeholder="Файл не выбран"></b-file>
        </div>
        <div class="col">
          <b-btn type="submit" variant="outline-primary" block>
            <b-spinner small v-if="loading"></b-spinner>
            Загрузить
          </b-btn>
        </div>
      </b-form-row>
    </b-form><br>
    <b-alert variant="success" :show="!loading && success">База данных успешно обновлена</b-alert>
    <b-alert variant="danger" :show="!loading && error">Ошибка при импорте компонентов</b-alert>
  </b-modal>
</template>

<script>

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      uploadForm: this.$inertia.form({
        file: null
      }),
      loading: false,
      success: false,
      error: false
    }
  },
  methods: {
    onUpload () {
      this.error = false
      this.success = false
      this.loading = true

      const data = new FormData()
      data.append('file', this.uploadForm.file)

      window.axios
        .post(
          this.route('backend.components.upload'),
          data,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
        .then(resp => {
          this.loading = false
          if (resp.data.status === 'OK') {
            this.success = true
            this.uploadForm.reset()
          }
        })
        .catch(() => {
          this.loading = false
          this.error = true
        })
    },

    onClose () {
      if (this.success && !this.error) {
        this.$inertia.reload()
      }

      this.error = false
      this.success = false
    }
  }
}
</script>
